import React from "react";
import styles from "./product-gallery-image.css";

interface NormalImageProps {
    image: ProductImage;
    onClick: () => void;
    isSingle: boolean;
    hasRelatedProductsSidebar: boolean;
}

function NormalImage({
    image,
    onClick,
    isSingle,
    hasRelatedProductsSidebar,
}: NormalImageProps): React.ReactElement {
    return (
        <div
            className={`${styles.normalImageWrapper} ${
                isSingle ? styles.normalImageWrapperSingle : ""
            } ${hasRelatedProductsSidebar ? styles.normalImageWrapperWithSidebar : ""}`}
            onClick={onClick}
        >
            <img
                className={styles.normalImage}
                alt={image.alt_text}
                src={image.large_url}
                srcSet={`${image.large_url} 1x, ${image.large_url_2x} 2x`}
            />
        </div>
    );
}

function FullScreenImage({ image }: { image: ProductImage }): React.ReactElement {
    return (
        <div className={styles.fullscreenImageWrapper}>
            <img
                alt={image.alt_text}
                src={image.large_url}
                srcSet={`${image.large_url} 1x, ${image.large_url_2x} 2x`}
            />
        </div>
    );
}

interface ImageProps {
    isFullscreen: boolean;
    image: ProductImage;
    onClick: () => void;
    isSingle: boolean;
    hasRelatedProductsSidebar: boolean;
}

function Image({
    isFullscreen = false,
    onClick,
    image,
    isSingle,
    hasRelatedProductsSidebar,
}: ImageProps): React.ReactElement {
    if (isFullscreen) {
        return <FullScreenImage image={image} />;
    }
    return (
        <NormalImage
            image={image}
            onClick={onClick}
            isSingle={isSingle}
            hasRelatedProductsSidebar={hasRelatedProductsSidebar}
        />
    );
}

export default Image;
